/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { updateDocumentDelivery } from 'services/Rest';
import { UPDATE_COMPLIANCE_SUBSCRIPTION } from 'state/preferences/PreferencesActions';
import {
  getPreferencesComplianceSubscriptions,
  getPrimaryEmailAddress
} from 'state/customer/CustomerSelectors';

const UpdateComplianceSubscriptionLogic = createLogic({
  type: UPDATE_COMPLIANCE_SUBSCRIPTION,

  // eslint-disable-next-line no-unused-vars
  process({ action, getState }, dispatch, done) {
    const state = getState();
    const complianceSubscriptions =
      getPreferencesComplianceSubscriptions(state);
    const emailAddress = getPrimaryEmailAddress(state);

    if (complianceSubscriptions.length > 0) {
      const payload = {
        subscriptions: {
          complianceSubscriptions
        }
      };
      //Need to send true to use and prevent analytics dispatch of DocumentDelivery
      updateDocumentDelivery(payload, emailAddress, true);
    }

    done();
  }
});

export default UpdateComplianceSubscriptionLogic;
